import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment } from 'react';
import styled from 'styled-components';
import Row from '../../node_modules/reactstrap/esm/Row.js';
import Col from '../../node_modules/reactstrap/esm/Col.js';
import Modal$1 from '../../node_modules/reactstrap/esm/Modal.js';
import ModalHeader$1 from '../../node_modules/reactstrap/esm/ModalHeader.js';
import Theme from '../../Theme/index.js';
import '../Dashboard/Panel.js';
import '../Dashboard/SectionHeader.js';
import { Button } from '../Dashboard/Button.js';
import '../Dashboard/Title.js';
import Checkbox from '../FormikFormHelpers/Checkbox.js';
import { GOOGLE_LOGIN_LINK } from './handleMailClick.js';
import getPgaTld from '../../getPgaTld.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var FlexColumn = styled(Col)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: self-end;\n\n  @media (max-width: 991.98px) {\n    margin-bottom: 20px;\n  }\n"])));
var ModalHeader = styled(ModalHeader$1)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-bottom: none;\n  position: absolute;\n  right: 10px;\n  z-index: 10;\n"])));
var Modal = styled(Modal$1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n"])));
var Title = styled.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n  margin-bottom: 1rem;\n"])), Theme.colors.primary, Theme.fonts.PlayfairDisplay);
var Header = styled(Title)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 20px;\n"])));
var baseParagraphStyles = "\n  color: ".concat(Theme.colors.primary, ";\n  font-family: ").concat(Theme.fonts.Montserrat, ";\n  font-size: 14px;\n  line-height: 21px;\n  margin-bottom: 1rem;\n");
var Paragraph = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), baseParagraphStyles);
var ExternalLink = styled.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n"])), Theme.colors.lightBlue, baseParagraphStyles);
var StyledButton = styled(Button)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 8px;\n  display: block;\n"])), Theme.fonts.Montserrat);
var PaddingWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 3rem;\n  height: 100%;\n  background-color: #e9ebee;\n  border-left: 1px solid #b4bdcc;\n  text-align: center;\n"])));
var SIGNUP_FORM_LINK = "https://docs.google.com/forms/d/e/1FAIpQLSc2aRVfGf71mXvrq0lHIyIKUBjv5G6OmGr15wooftY7fU38cw/viewform";
var pgaTld = getPgaTld();
var LoginContent = function LoginContent(_ref) {
  var tempPassword = _ref.meEmailMigrationData.tempPassword,
    onToggleDoNotShowAgain = _ref.onToggleDoNotShowAgain;
  var goLogin = function goLogin() {
    return window.location.assign(GOOGLE_LOGIN_LINK);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, null, "Your PGA.com email account is now in Gmail!"), /*#__PURE__*/React__default.createElement(Paragraph, {
    className: "text-left"
  }, "Your account has been moved to Gmail as part of our effort to bring members a more secure email solution. If you haven\u2019t logged in yet, use the temporary password provided. You\u2019ll be prompted to update it before you get started."), /*#__PURE__*/React__default.createElement(Row, {
    className: "text-left mt-4"
  }, /*#__PURE__*/React__default.createElement(FlexColumn, {
    lg: "6",
    md: "12"
  }, /*#__PURE__*/React__default.createElement(Header, null, "I've already reset my password."), /*#__PURE__*/React__default.createElement(Paragraph, null, "Great! If you want to bypass this message in the future and go right to your login, check the box below."), /*#__PURE__*/React__default.createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    darker: true,
    label: "Don\u2019t show this again.",
    fontSize: "15px",
    field: {
      onChange: onToggleDoNotShowAgain
    }
  })), /*#__PURE__*/React__default.createElement(StyledButton, {
    onClick: goLogin
  }, "Login")), /*#__PURE__*/React__default.createElement(FlexColumn, {
    lg: "6",
    md: "12"
  }, /*#__PURE__*/React__default.createElement(Header, null, "I haven't logged in yet."), /*#__PURE__*/React__default.createElement(Paragraph, null, "The first time you access your account, you\u2019ll need to use the temporary password below. You\u2019ll be prompted to update it as soon as you login."), tempPassword && /*#__PURE__*/React__default.createElement(Paragraph, null, /*#__PURE__*/React__default.createElement("strong", null, "Temporary Password: ", tempPassword)), /*#__PURE__*/React__default.createElement(StyledButton, {
    onClick: goLogin
  }, "Login"))), /*#__PURE__*/React__default.createElement("div", {
    className: "mt-4 text-left"
  }, /*#__PURE__*/React__default.createElement(Paragraph, null, "To access the current email system before you're fully migrated to Gmail,", " ", /*#__PURE__*/React__default.createElement("a", {
    href: "https://webmail.pgalinks.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "click here.")), /*#__PURE__*/React__default.createElement(Paragraph, {
    className: "mb-0"
  }, "Need help? Visit the Gmail Resources page on", " ", /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.".concat(pgaTld, "/gmail-resources"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "PGA.org"))));
};
var AllowedSignupContent = function AllowedSignupContent(_ref2) {
  var toggle = _ref2.toggle;
  var goSignup = function goSignup() {
    return window.location.assign(SIGNUP_FORM_LINK);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, null, "Signup for a PGA.com email address"), /*#__PURE__*/React__default.createElement(Paragraph, {
    className: "text-left"
  }, "PGA of America offers free PGA.com email to Members in good standing. If you would like a PGA.com email address, please request one at the link below."), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column align-items-center mt-4"
  }, /*#__PURE__*/React__default.createElement(StyledButton, {
    onClick: goSignup
  }, "Signup"), /*#__PURE__*/React__default.createElement(ExternalLink, {
    className: "mt-2",
    onClick: toggle
  }, "No thanks I'll do it later")), /*#__PURE__*/React__default.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/React__default.createElement(Paragraph, null, "If you think you landed here by mistake, and you already have a PGA.com email account, please call Membership Services at", " ", /*#__PURE__*/React__default.createElement("a", {
    href: "tel:18004742776"
  }, "1-800-474-2776"), ".")));
};
var NotAllowedSignupContent = function NotAllowedSignupContent(_ref3) {
  var toggle = _ref3.toggle;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, null, "Signup for a PGA.com email address"), /*#__PURE__*/React__default.createElement(Paragraph, {
    className: "text-left"
  }, "You must be a PGA Member, Student or Associate to be eligible for a PGA.com email account."), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column align-items-center mt-4"
  }, /*#__PURE__*/React__default.createElement(StyledButton, {
    onClick: toggle
  }, "Close window")));
};
var SignupContent = function SignupContent(_ref4) {
  var toggle = _ref4.toggle,
    _ref4$me = _ref4.me,
    me = _ref4$me === void 0 ? {} : _ref4$me;
  return ["MB", "AP"].includes(me.type) ? /*#__PURE__*/React__default.createElement(AllowedSignupContent, {
    toggle: toggle
  }) : /*#__PURE__*/React__default.createElement(NotAllowedSignupContent, {
    toggle: toggle
  });
};
var HeaderMailModal = (function (_ref5) {
  var open = _ref5.open,
    onToggle = _ref5.onToggle,
    type = _ref5.type,
    meEmailMigrationData = _ref5.meEmailMigrationData,
    onToggleDoNotShowAgain = _ref5.onToggleDoNotShowAgain,
    me = _ref5.me;
  var toggle = function toggle() {
    return onToggle(false);
  };
  var passProps = {
    toggle: toggle,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain,
    me: me
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: open,
    toggle: toggle,
    size: "lg",
    centered: true
  }, /*#__PURE__*/React__default.createElement(ModalHeader, {
    toggle: toggle
  }), /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, {
    lg: "12"
  }, /*#__PURE__*/React__default.createElement(PaddingWrapper, null, type === "gmailLogin" ? /*#__PURE__*/React__default.createElement(LoginContent, passProps) : /*#__PURE__*/React__default.createElement(SignupContent, passProps)))));
});

export { AllowedSignupContent, LoginContent, Modal, NotAllowedSignupContent, SignupContent, StyledButton, HeaderMailModal as default };
